import { xLocalStorage } from "@/core/services/xLocalStorage.service";

const i18nService = {
  defaultLanguage: "fa",

  languages: [
    {
      lang: "fa",
      name: "Persian",
      flag: "",
      rtl: true,
      culture: "fa-IR",
      firstDayOfWeek: 6
    }
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    xLocalStorage.set("language", lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return xLocalStorage.get("language") || this.defaultLanguage;
  },

  /**
   * Get the current active language flag
   * @returns {string | string}
   */
  getActiveLanguageFlag() {
    return this.languages.find(val => {
      return val.lang === this.getActiveLanguage();
    }).flag;
  },

  /**
   * Get the current active language culture
   * @returns {string | string}
   */
  getActiveLanguageCulture() {
    return this.languages.find(val => {
      return val.lang === this.getActiveLanguage();
    }).culture;
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  isActiveLanguageDirectionRtl() {
    return this.languages.find(val => {
      return val.lang === this.getActiveLanguage();
    }).rtl;
  },

  /**
   * Get the current active language lang
   * @returns {string | string}
   */
  getActiveLanguageLang() {
    return this.languages.find(val => {
      return val.lang === this.getActiveLanguage();
    }).lang;
  },
  getActiveLanguageFirstDayOfWeek() {
    return this.languages.find(val => {
      return val.culture === this.getActiveLanguageCulture();
    }).firstDayOfWeek;
  }
};

export default i18nService;
